<template>
  <div class="help">
    <div class="navbar_style" :class="$store.state.user.isNested && 'navbar_style_nested'">
      <Icon class="navbar_icon" name="arrow-left" @click="$router.back(1)"/>
      <span>{{ l.my_cell_list_help }}</span>
      <div class="icon_box"></div>
    </div>
    <div class="q_tab">
      <div
          class="qes"
          @click="switchTab(index)"
          :class="index == active && 'qes_select'"
          v-for="(item, index) in qesTab"
          :key="index"
      >
        {{ item }}
      </div>
    </div>

    <div class="qes_content">
      <div class="down_info" v-for="(item, index) in currentQes" :key="index">
        <div
            class="title"
            :class="item.isSelect && 'title_select'"
            @click="() => (item.isSelect = !item.isSelect)"
        >
          <div class="text">{{ item.title }}</div>
          <img
              class="info_img"
              :class="item.isSelect && 'info_img_select'"
              :src="item.isSelect?require('@/assets/my/down2@2x.png'):require('@/assets/my/down@2x.png')"
              alt=""
          />
          <!-- <Icon
            class="icon"
            color="#232425"
            :name="!item.isSelect ? 'arrow-down' : 'arrow-up'"
          /> -->
        </div>
        <div
            class="desc icon-plus"
            v-if="item.isSelect"
            v-html="item.desc"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import {Icon} from "vant";
import l from "../../locales";

export default {
  name: "help",
  components: {
    Icon,
  },
  data() {
    return {
      active: 0,
      activeNames: [],
      activeNames1: [],
      activeNames2: [],
      l: l.my,
      qesTab: [
        l.my.my_help_loan_issue,
        l.my.my_help_release_issue,
        l.my.my_help_repay_issue,
      ],
      //todo
      qesContents: [
        [
          {
            title: "1. Ai có thể sử dụng dịch vụ vay của 榮耀貸?",
            desc: `榮耀貸 cung cấp dịch vụ cho khách hàng
                                    với các điều kiện sau: <br />
                                    - Bạn có tài khoản ngân hàng (không dùng tài
                                    khoản của người thân). <br />
                                    - Đáp ứng các yêu cầu về nhân thân theo quy
                                    định của 榮耀貸 .`,
            isSelect: false,
          },
          {
            title: "2. Làm sao để đăng ký vay?",
            desc: `Sau khi bạn tải ứng dụng 榮耀貸: - Bước
                                    1: Đăng ký tài khoản đăng nhập với số điện
                                    thoại bạn đang sử dụng. <br />
                                    - Bước 2: Điền tất cả thông tin yêu cầu tại
                                    mục “Thông Tin”
                                    <br />
                                    - Bước 3: Tại mục “Vay tiền”, hãy gửi yêu
                                    cầu vay cho chúng tôi.`,
            isSelect: false,
          },
          {
            title: "3. Thủ tục vay cần những giấy tờ gì?",
            desc: `- CMND/CCCD. <br />
                                    - Thông tin tài khoản ngân hàng của chính
                                    người vay (không dùng tài khoản của người
                                    thân).`,
            isSelect: false,
          },
          {
            title: "4. Lãi suất, phí như thế nào?",
            desc: `Để xem chi tiết khoản vay, bạn điền đầy đủ
                                    thông tin sau đó vào mục “vay tiền” chọn
                                    “vay ngay” và chọn “nhấn để gửi” để tham
                                    khảo khoản vay trước khi gửi yêu cầu. <br />
                                    - Lãi suất và phí dịch vụ đã được quy định
                                    trong hợp đồng.`,
            isSelect: false,
          },
          {
            title:
                "5. Tôi điền thông tin cá nhân trên ứng dụng 榮耀貸 có an toàn không?",
            desc: `榮耀貸 sẽ dựa vào thông tin bạn cung
                                    cấp để đánh giá xét duyệt yêu cầu vay và đảm
                                    bảo sẽ bảo mật thông tin của bạn, tuyệt đối
                                    không dùng thông tin của khách hàng với mục
                                    đích khác.`,
            isSelect: false,
          },
        ],
        [
          {
            title: "1. Tôi muốn biết tình trạng khoản vay",
            desc: `Yêu cầu vay của bạn sẽ được xử lý trong “CÔNG TY TNHH DỊCH VỤ THUẬN HẢI” sẽ có thông báo, bạn có thể chủ
                                    động nhận khoản vay của mình tại mục “Hóa
                                    đơn”, sau khi nhận thành công bạn sẽ nhận
                                    được tiền.`,
            isSelect: false,
          },
          {
            title: "2. Làm sao tôi biết hồ sơ của mình đã được giải ngân?",
            desc: `một khi giải ngân thành công, bạn sẽ nhận
                                    được tin nhắn thông báo, bạn cũng có thể tại
                                    app, vào trang "Đơn vay" hàng để xem trạng
                                    thái mới nhất.`,
            isSelect: false,
          },
          {
            title:
                "3. Tôi nhận được thông báo giải ngân, nhưng vẫn chưa nhận được tiền?",
            desc: `chúng tôi đã gửi yêu cầu chuyển khoản đến
                                    ngân hàng, thời gian đến cụ thể tùy thuộc
                                    vào ngân hàng.`,
            isSelect: false,
          },
        ],
        [
          {
            title: "1. Làm sao tôi biết khoản vay của tôi đã đến hạn?",
            desc: `Khi bạn gửi yêu cầu vay, 榮耀貸 có đính
                                    kèm ngày đến hạn khoản vay hoặc bạn có thể
                                    vào lịch sử khoản vay để kiểm tra. Ngoài ra,
                                    榮耀貸 sẽ gửi đến bạn tin nhắn thông
                                    báo khi gần đến hạn thanh toán. 榮耀貸
                                    khuyến khích bạn thanh toán sớm hơn để tránh
                                    phát sinh phí phạt.`,
            isSelect: false,
          },
          {
            title:
                "2. Sau khi thanh toán, làm sao tôi biết 榮耀貸 đã nhận được tiền của tôi?",
            desc: `Khi 榮耀貸 nhận được khoản thanh toán
                                    của bạn sẽ gửi đến bạn một thông báo xác
                                    nhận.`,
            isSelect: false,
          },
          {
            title: "3. Tôi thanh toán trễ có được không?",
            desc: `榮耀貸 khuyến khích bạn thanh toán sớm
                                    hoặc đúng hạn. 榮耀貸 <br />
                                    - Tránh phát sinh thêm phí phạt. <br />
                                    - Tránh ảnh hưởng đến việc xét duyệt yêu cầu
                                    vay lần sau.
                                    <br />
                                    - Tránh ảnh hưởng đến lịch sử vay tín dụng
                                    của bạn. <br />
                                    - Tránh các biện pháp thu hồi nợ hoặc khởi
                                    kiện theo quy định hiện hành <br />`,
            isSelect: false,
          },
        ],
      ],

      currentQes: [],
    };
  },
  created() {
    this.currentQes = this.qesContents[this.active];
  },
  methods: {
    switchTab(index) {
      this.active = index;
      this.currentQes = this.qesContents[index];
    },
  },
};
</script>

<style lang="less" scoped>
.help{
  background: #F8FBFF;
  height: 100%;
  min-height: 100vh;
}
.down_info {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-top: 20px;

  .title {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    padding-right: 26px;
    box-sizing: border-box;

    width: 345px;
    height: 40px;
    background: #FFFFFF;
    box-shadow: 0px 0px 5px 0px rgba(56,151,229,0.2);
    border-radius: 8px;

    font-size: 13px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #28435B;
    line-height: 18px;



    .text {
      width: 280px;
      margin-left: 15px;

      &::first-letter {
        font-size: 16px;
        font-weight: 500;
        color: #3f414c;
      }
    }

    .info_img {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 20px;
      width: 24px;
      height: 24px;
    }

    .info_img_select {
      transform: translateY(-50%);
    }

    .icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 10px;
    }
  }

  //.title_select {
  //  background: rgba(69,161,255,0.6);
  //
  //  color: #FFFFFF;
  //  .text {
  //    &::first-letter {
  //      color: #FFFFFF;
  //    }
  //  }
  //
  //}

  .desc {
    padding: 12px 9px;
    padding-top: 20px;
    box-sizing: border-box;
    transform: translateY(-8px);

    width: 325px;
    background: #FFFFFF;
    box-shadow: 0px 0px 5px 0px rgba(56,151,229,0.2);
    border-radius: 0px 0px 8px 8px;

    font-size: 12px;
    font-family: Helvetica;
    color: #516A80;
    line-height: 20px;



  }
}

.down_info:first-child {
  margin-top: 22px;
}

.q_tab {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  margin-top: 20px;

  .qes {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    flex: 1;
    border: none;

    box-sizing: border-box;

    background: rgba(255,255,255,0.5);
    border-radius: 15px;
    border: 1px solid #B0B0B0;

    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #959DA8;

    height: 42px;

    margin-right: 6px;

    &:last-child {
      margin-right: 0;
    }
  }

  .qes_select {
    pointer-events: none;

    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #00819F;

    background: rgba(16,103,219,0.1);
    border-radius: 15px;
    border: 1px solid #00819F;


  }
}

.produce {
  background: #fff;
  padding-top: 1px;
  margin-bottom: 30px;

  .produce_title {
    text-align: center;
    font-size: 14px;
    color: #333333;
    margin: 20px 0;
  }

  .produce_con {
    display: flex;
    justify-content: space-around;
    padding: 20px;
    box-sizing: border-box;

    .produce_item {
      // flex: 1;
      width: 40px;
      text-align: center;

      img {
        width: 100%;
      }
    }
  }
}

.tab_con {
  .Collapse_icon {
    // background: blue;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 5px;

    > div {
      width: 18px;
      height: 18px;
      font-size: 14px;
      background-image: linear-gradient(360deg, #fcd476 0%, #fe9e44 100%);
      color: #fff;
      text-align: center;
      line-height: 18px;
      border-radius: 3px;
      transform: scale(0.8);
    }
  }

  .Collapse_con {
    // background-color: #f7f9fb;
    display: flex;

    .Collapse_con_icon {
      margin-right: 5px;

      > div {
        width: 18px;
        height: 18px;
        font-size: 14px;
        background: rgb(181, 180, 180);
        color: #fff;
        text-align: center;
        line-height: 18px;
        border-radius: 3px;
        transform: scale(0.8);
      }
    }
  }
}

/deep/ .van-collapse-item__content {
  background-color: #f7f9fb !important;
}
</style>
